import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faNotesMedical,
  faPaperPlane,
  faTimes,
  faSpinner,
  faHeart,
  faAllergies,
  faClock,
  faMoon,
  faPlus,
  faSignOutAlt
} from "@fortawesome/free-solid-svg-icons";
import {
  faUserCircle,
  faComment,
  faImage,
  faTimesCircle,
  faClipboard
} from "@fortawesome/free-regular-svg-icons";
import FontAwesomeIcon from "@/libs/FontAwesomeIcon.vue";

library.add(
  faUserCircle,
  faComment,
  faNotesMedical,
  faImage,
  faPaperPlane,
  faTimes,
  faSpinner,
  faHeart,
  faAllergies,
  faClock,
  faMoon,
  faTimesCircle,
  faClipboard,
  faPlus,
  faSignOutAlt
);

export { FontAwesomeIcon };
